// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__31sDd","title":"InfoRow_title__1CbuY"};